import { request } from './request';

export const getAllPolygraphies = (page = 1, filterString = '', limit = 50) =>
  request(`polygraphies?page=${page}${filterString}&limit=${limit}`);

export const getPolygraphyById = (id) => request(`polygraphies/${id}`);

export const updatePolygraphy = (id, body) =>
  request(`polygraphies/${id}`, { method: 'PATCH', body });

export const createPolygraphy = (body) =>
  request(`polygraphies`, { method: 'POST', body });

export const deletePolygraphy = (id, body) =>
  request(
    `polygraphies/${id}`,
    { method: 'DELETE', body },
    'Polygraphy deleted successfully!',
  );
